module.exports = __webpack_public_path__ + "static/media/max.4248c2b1.jpg";